import React from 'react';
import { GlobalSideNavigation } from '@atlassian/global-side-navigation';
import type { SidebarId } from '@atlassian/jira-route-types/src/Navigation.tsx';

type Props = {
	sidebarId: SidebarId;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function GSNForOtherSidebars({ sidebarId }: Props): React.JSX.Element {
	/*
	  TODO:
		    1. render other sidebars within `postMainElement`
			2. disable customisation
			3. Return GSN component
	*/

	return (
		<GlobalSideNavigation
			app="jira"
			appLabel="Jira"
			customizationStore="local"
			forYou={{}}
			items={{}}
			testId="nav-platform-integration-sidebar.ui.jira-other-sidebars"
		/>
	);
}
